import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BasePersona, IAMService, PartnerPersona, PersonaType } from '@vendasta/iam';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

export interface PartnerPersonaWithPartnerId extends PartnerPersona {
  partnerId: string;
}
interface LogoutResponseInterface {
  nextUrl: string;
}

// TODO: Move into iam SDK?
@Injectable()
export class AuthApiService {
  constructor(private iamService: IAMService, private http: HttpClient) {}

  login(credentials: { email: string; password: string }): Observable<string> {
    let _sessionId = '';
    return this.iamService.login(credentials.email, credentials.password).pipe(
      switchMap((sessionId: string) => {
        _sessionId = sessionId;
        return this.iamService.listPersonas(sessionId);
      }),
      map((personas: BasePersona[]) => {
        let isSuperAdmin = false;
        let hasAuth = false;
        for (const persona of personas) {
          switch (persona.type) {
            case PersonaType.partner:
              isSuperAdmin = (persona as PartnerPersona).isSuperAdmin;
              hasAuth = true;
              break;
            case PersonaType.vendor:
              hasAuth = true;
          }
          if (isSuperAdmin) {
            break;
          }
        }
        if (!hasAuth) {
          throw new HttpErrorResponse({ status: 403 });
        }
        return _sessionId;
      }),
    );
  }

  logout(partnerId: string): Observable<string> {
    return this.http
      .post<LogoutResponseInterface>('/logout', { partnerId: partnerId })
      .pipe(map((response: LogoutResponseInterface) => response.nextUrl));
  }

  getPartnerPersonaBySession(sessionId: string): Observable<PartnerPersonaWithPartnerId> {
    return this.iamService.getSubjectBySession(
      sessionId,
      PersonaType.partner,
    ) as Observable<PartnerPersonaWithPartnerId>;
  }
}
